import React from 'react';

function Header() {
	return (
	<header>
		<div class="row">
			<div class="col-md-2">
				<div class="logo">
					<a href="/"><img src={`${process.env.PUBLIC_URL}/images/logo.png`}  /></a>
				</div>
			</div>
			<div class="col-md-10">
				<div class="mobilenav">
				    <a href="#" class="mobileicon">
						<img src={`${process.env.PUBLIC_URL}/images/mobilenav.png`} />
					</a>
				</div>
				<div class="floatRight">
					<a href=""><img src={`${process.env.PUBLIC_URL}/images/select.png`} /></a>
					<div class="image">
						<img src={`${process.env.PUBLIC_URL}/images/Lunar.png`} />
					</div>
					<a href="#"><img src={`${process.env.PUBLIC_URL}/images/connectbtn.png`} /></a>
				</div>
			</div>
		</div>
	</header>
	);
}

export default Header;